<svelte:component this={currentRoute} />

<EditorModal isVisible={$photo.isEditingPhoto.state}>
  <PhotoEditor />
  <EditorFooter
    isPhoto=true
    backText="Use Other Photo"
    forwardText="Crop and Save"
    save="{savePhotoEdits}"/>
</EditorModal>

<MessageModal
  isVisible={$store.isChoosingMessage.state}
  toggleMessageModal="{toggleMessageModal}">
  <MessageChooser
    chosenMessage={$store.message}
    occasions={[...$store.occasions]}
    messages={[...$store.messages]}
    logoSrc={$theme.logoSrc.state}
    select="{event => selectOccasion(event)}"
    choose="{event => toggleMessage(event)}"
    setText="{event => setText(event)}"
    toggleMessageModal="{toggleMessageModal}"/>
</MessageModal>

<ColorModal
  isVisible={$store.showColorModal.state}
  toggleModal="{() => store.set($store.showColorModal.toggle())}">
  <ColorChooser />
</ColorModal>

<FontModal
  isVisible={$store.showFontModal.state}
  toggleModal="{() => store.set($store.showFontModal.toggle())}">
  <FontChooser />
</FontModal>

<Notifications notifications={errors} removeCallback={remove} />

<script>
  import pkg from "../package.json";
  import EditorModal from './components/EditorModal.html';
  import MessageModal from './components/MessageModal.html';
  import PhotoEditor from './components/PhotoEditor.html';
  import MessageChooser from './components/MessageChooser.html';
  import EditorFooter from './components/EditorFooter.html';
  import { fly } from 'svelte-transitions';
  import Notifications from './components/Notifications.html';
  import { valueOf } from 'microstates';
  import { router, store, history, theme, photo, destroy } from './stores';
  import { onDestroy, onMount, createEventDispatcher } from 'svelte';
  import polyfills from './lib/polyfills'
  import ConfirmRoute from './routes/ConfirmRoute.html';
  import EditRoute from './routes/EditRoute.html';
  import ColorModal from './components/ColorModal.html';
  import ColorChooser from './components/ColorChooser.html';
  import FontModal from './components/FontModal.html';
  import FontChooser from './components/FontChooser.html';

  export const dispatch = createEventDispatcher();

  const routes = {
    edit: EditRoute,
    confirm: ConfirmRoute
  }

  $: errors = valueOf($store.errors.errors);
  $: currentRoute = routes[$router.current];

  onMount(() => {
    window.NOTE_EDITOR_VERSION = `
      this is a bit quirky but we do not actually have the current version. we do know the previous version though: ${pkg.version}
      at some point we should fix this. we need to update the packing process to
        1. version the app for release
        2. build the app
        3. push to npm.

      instead of what we do now which is
        1. build the app
        2. version the app for release and push to npm

    see https://github.com/lovepopcards/galdr/releases for the latest release.
    `;

    polyfills();


    if ($store.shouldRenderFromServer.state) {
      router.set($router.to('edit'));
    }
  });

  onDestroy(destroy);

  export function loaded() {
    store.set($store.loaded.set(true));
  }

  function goTo(route) {
    router.set($router.to(route));
  };

  function remove(id) {
    store.set($store.errors.remove(id));
  };

  function selectOccasion(occasionTitle) {
    store.set($store.selectOccasion(occasionTitle));
  };

  function toggleMessage({ checked, value }) {
    store.set($store.toggleMessage({ checked, value }));
  };

  function cancelEdits() {
    const prevState = $history.current;
    store.set(prevState);
    history.set($history.undo());
  };

  async function savePhotoEdits() {
    const cropper = $photo.cropper.state;

    const blob = await new Promise((res) => {
      cropper.getCroppedCanvas().toBlob(res);
    });
    const reader = new FileReader();

    reader.onload = function({ target: { result }}) {
      const newPhoto = $photo.isChangingPhoto.set(false);
      photo.set(newPhoto.commitPhotoEdits(result).blob.set(blob));
    };

    reader.readAsDataURL(blob);
  }

  function setText(text) {
    store.set($store.setText(text));
  };

  function toggleMessageModal() {
    store.set($store.isChoosingMessage.toggle());
  };
</script>
